// @ts-nocheck
import React, {useEffect, useState} from "react";
import pdfMake from "pdfmake/build/pdfmake";
// eslint-disable-next-line import/no-extraneous-dependencies
import "@react-pdf-viewer/core/lib/styles/index.css";
// eslint-disable-next-line import/no-extraneous-dependencies
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import { customVfs } from '../../../assets/CustomVfsFonts';
import moment from "moment";
import { convert as convertNumberToWordsRu } from 'number-to-words-ru' // ES6
import 'moment/locale/ru'


const GenerateContract = ({isShowContract=false, request, setGeneratedContract, contract, emergency_org, emergency_city}) => {
  moment.locale("ru");
  const [pdfUrl, setPdfUrl] = useState(null);
  const now = moment();
  // console.log(today, "today");
  pdfMake.vfs = {
    ...pdfMake.vfs,
    ...customVfs
  };
  pdfMake.fonts = {
    ...pdfMake.fonts,
    TimesNewRoman: {
      normal: 'TimesNewRoman.ttf',
      bold: 'TimesNewRomanBold.ttf',
      italics: 'TimesNewRomanItalic.ttf',
      bolditalics: 'TimesNewRomanBoldItalic.ttf'
    },
  };
  const totalSum = request?.invoice.reduce((sum, item) => {
    return sum + parseFloat(item.total);
  }, 0);
  const contractStart = `Договор действует с «${moment(now).format('DD')}» ${moment(now).format('MMMM')} ${moment(now).format('YYYY')}г. ${moment(now).format('HH:mm')}`
  const contractEnd = request.type === 3 ? `по «${moment(request?.contractUntil).format('DD')}» ${moment(request?.contractUntil).format('MMMM')} ${moment(request?.contractUntil).format('YYYY')}г. ${moment(request?.contractUntil).format('HH:mm')}` : ''
  const generatePdf = () => {

    const docDefinition = {
      pageMargins: [40, 40, 40, 40],

      content: [
        {
          text: 'Оферта на оказание Услуг корпоративным клиентам сервиса',
          style: 'header',
          alignment: 'center',
        },
        {
          text: `г. ${request.city}                                         «${contract && contract.created_at ? moment(contract.created_at).format('DD') :now.format('DD')}» ${contract && contract.created_at ? moment(contract.created_at).format('MM') : now.format('MM')} ${contract && contract.created_at ? moment(contract.created_at).format('YYYY') :now.format('YYYY')}г.`,
          alignment: 'center',
          style: 'smallText',
          margin: [0, 10, 0, 20]
        },
        {
          stack: [
            {
              text: [
                { text: ` ${request.customer.organization_name}`, bold: true },
                ', именуемая в дальнейшем «Заказчик», в лице ',
                { text: `${request?.customer?.director_name}`, bold: true },
                ' действующего на основании устава с одной стороны и ОБЩЕСТВО С ОГРАНИЧЕННОЙ ОТВЕТСТВЕННОСТЬЮ «МЕДИТ ГРУПП», именуемое в дальнейшем «Сервис temp03», в лице Генерального Директора Вадачкория Анны Гизоевны, с другой стороны, именуемые вместе «Стороны», заключили настоящий Договор о нижеследующем:'
              ],
              // lineHeight: 1.4,
              margin: [0, 0, 0, 20]
            },
            // {
            //   absolutePosition: { x: 45, y: 112 }, // adjust Y to match underline
            //   text: request.name,
            //   fontSize: 11,
            //   bold: true
            // }
          ]
        },
        {
          text: 'Термины',
          style: 'sectionHeader',
          margin: [0, 10, 0, 5]
        },
        {
          text: [
            'Корпоративный Пользователь — Пользователь, номер телефона которого зарегистрирован в личном кабинете Заказчиком в программном комплексе ТЭМП03 ',
            { text: '(Сервис temp03) ', bold: true },

            { text: 'https://temp03.ru', link: 'https://temp03.ru', color: 'blue', decoration: 'underline' },
            ' в установленном порядке и правилах системы.'
          ],
          margin: [0, 0, 0, 8],
          fontSize: 12,
          lineHeight: 1
        },
        {
          text: [
            'Запрос — размещенная Корпоративным Пользователем и/или уполномоченным представителем Заказчика в Личном кабинете информация о потенциальном спросе на Услуги Партнеров Сервиса.'
          ],
          margin: [0, 0, 0, 12],
          fontSize: 12,
          lineHeight: 1
        },



        { text: 'Преамбула', style: 'sectionHeader' },
        {
          text: [
            'Настоящий документ (далее — «Оферта») представляет собой предложение Общества с ограниченной ответственностью «МЕДИТ ТЭМП03» (далее — ',
            { text: '«МЕДИТ ТЭМП03»', bold: true },
            '), заключить Заказчику (как определено далее), являющемуся юридическим лицом или индивидуальным предпринимателем, договор на изложенных ниже условиях (далее — «Договор»).'
          ],
          margin: [0, 0, 0, 12],
          lineHeight: 1
        },
        {
          text: [
            'Настоящая Оферта является бессрочной. ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' может в любой момент отозвать Оферту, что не должно влиять на Договоры, которые были заключены с Заказчиками до даты такого отзыва.'
          ],
          margin: [0, 0, 0, 12],
          lineHeight: 1
        },
        {
          text: [
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' вправе в одностороннем порядке вносить изменения в настоящую Оферту (во избежание сомнений, включая, но не ограничиваясь в условия Договора, заключенного посредством акцепта Оферты) путем опубликования новой версии Оферты по следующей ссылке в сети Интернет: ',
            { text: 'https://temp03.ru', link: 'https://temp03.ru', color: 'blue', decoration: 'underline' },
            ' и Условия оказания услуг, путем опубликования новой версии по следующей ссылке в сети Интернет: ',
            { text: 'https://temp03.ru', link: 'https://temp03.ru', color: 'blue', decoration: 'underline' }
          ],
          margin: [0, 0, 0, 12],
          lineHeight: 1
        },
        {
          text: 'Обновленные версии Оферты и Условий оказания услуг вступают в законную силу с момента их опубликования по указанным выше ссылкам в сети Интернет. Заказчик, в случае заключения Договора, обязуется регулярно ознакамливаться с настоящей Офертой и Условиями оказания услуг на предмет внесения в них изменений.',
          margin: [0, 0, 0, 12],
          lineHeight: 1
        },
        {
          text: 'Порядок акцепта Оферты Заказчиком',
          style: 'sectionHeader',
          alignment: 'center'
        },
        {
          text: [
            'Заказчик осуществляет акцепт Оферты путем совокупного совершения следующих действий:'
          ],
          margin: [0, 0, 0, 10]
        },
        {
          text: [
            '1) зарегистрироваться на доступном ресурсе (веб-интерфейсе) ',
            { text: 'Сервис temp03', bold: true },
            ' ',
            { text: 'https://temp03.ru', link: 'https://temp03.ru', color: 'blue', decoration: 'underline' },
            ', а также предоставить полные, точные и достоверные документы и информацию, запрашиваемые в ходе регистрации (далее — «Процедура Регистрации»), а также предоставить иные документы и информацию, если такие документы и информация запрашиваются ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' в Личном кабинете Заказчика. В случае, если ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' будет обнаружено предоставление неполных и/или неточных и/или недостоверных данных и документов, ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' может предложить Заказчику исправить предоставленную информацию или может отказать в заключении Договора.'
          ],
          margin: [0, 0, 0, 12],
        },
        {
          text: [
            '2) Нажатие на кнопку «Я ознакомился, согласен и полностью принимаю условия Оферты» (или аналогичной по смыслу), доступную на ресурсе (веб-интерфейсе) МЕДИТ: ',
            { text: 'https://temp03.ru', link: 'https://temp03.ru', color: 'blue', decoration: 'underline' }
          ],
          margin: [0, 0, 0, 12],
        },
        {
          text: [
            '3) Совершение действия, указанного в п. 4 или в п. 5 Оферты:\n\n',
            '4) Формирование счета на оплату Услуг в Личном кабинете (как определено далее) на сумму от 1 000 (одной тысячи) руб. и оплата указанного счета не позднее 5 (пяти) календарных дней с момента формирования счета с расчетного счета Заказчика.\n\n',
            '5) Подключение к предложенной в Личном кабинете системе обмена информации. Акцепт Заказчиком настоящей Оферты в порядке, предусмотренном выше, порождает заключение Договора в порядке, предусмотренном ст. 438 ГК РФ, на условиях настоящей Оферты.\n\n',
            '6) Акцепт является подтверждением полного и безоговорочного согласия Заказчика с условиями настоящей Оферты. Акцепт Оферты с изъятиями/дополнения не допускается. Акцептуя настоящую Оферту, лицо, совершающее акцепт Оферты в предусмотренном порядке, подтверждает и заверяет, что оно уполномочено на совершение такого действия от имени Заказчика и обладает всеми необходимыми правами и разрешениями, необходимыми для совершения такого действия от имени Заказчика. В случае нарушения такого заверения, лицо, акцептовавшее Оферту, обязуется возместить убытки ',
            { text: 'МЕДИТ', bold: true },
            ' по письменному требованию.'
          ],
          margin: [0, 0, 0, 16],
        },
        { text: 'Условия Договора, заключаемого посредством акцепта Оферты:\n' },
        {
          text: '1. Термины\n',
          style: 'sectionHeader',
          alignment: 'center',
          margin: [0, 20, 0, 16],
        },
        {
          text: [
            '1.1. ',
            { text: 'Сервис temp03', bold: true },
            ', Сервис — программно-аппаратный комплекс, позволяющий Заказчику размещать Запросы на Услуги Партнеров, и осуществляющий автоматическую обработку и передачу таких Запросов Партнерам.'
          ],
          margin: [0, 0, 0, 8],
        },
        {
          text: [
            '1.2. Услуги Партнеров – услуги, доступные для заказа с использованием ',
            { text: 'Сервис temp03', bold: true },
            ', оказываемые Партнерами в соответствии с Условиями оказания услуг, доступными в сети Интернет по адресу: ',
            { text: 'https://temp03.ru', link: 'https://temp03.ru', color: 'blue', decoration: 'underline' }
          ],
          margin: [0, 0, 0, 8],
        },{
          text: '1.3. Партнер — юридическое лицо, индивидуальный предприниматель, оказывающий Заказчику Услуги Партнеров.',
          margin: [0, 0, 0, 5],
        },
        {
          text: '1.4. Корпоративный Пользователь — Пользователь, номер телефона которого передан Заказчиком Яндексу в порядке, установленном п. 4.1.2. Договора.',
          margin: [0, 0, 0, 5],
        },
        {
          text: '1.5. Запрос — размещенная Корпоративным Пользователем и/или уполномоченным представителем Заказчика в Личном кабинете информация о потенциальном спросе на Услуги Партнеров.',
          margin: [0, 0, 0, 10],
        },
        {
          text: [
            '1.6. Личный кабинет — раздел Сайта ',
            { text: 'Сервис temp03', bold: true },
            ' ',
            { text: 'https://temp03.ru', link: 'https://temp03.ru', color: 'blue', decoration: 'underline' },
            ', который содержит информацию о Заказчике, Данные статистики и иную информацию в отношении Услуг (как определено в п. 2.1. Договора), а также который предоставляет возможность удаленного взаимодействия Сторон в рамках Договора, в том числе для поддержания перечня Корпоративных Пользователей в актуальном состоянии, доступный Заказчику после авторизации на Сайте Яндекса с использованием логина и пароля Заказчика.'
          ],
          margin: [0, 0, 0, 10],
        },
        {
          text: [
            '1.7. Данные статистики — данные систем автоматизированного учета информации ',
            { text: 'Сервис temp03', bold: true },
            ' ',
            { text: 'https://temp03.ru', link: 'https://temp03.ru', color: 'blue', decoration: 'underline' },
            ' в электронном виде, которые могут содержать сведения для расчета стоимости Услуг и иные сведения, относящиеся к процессу оказания Услуг по настоящему Договору.'
          ],
          margin: [0, 0, 0, 10],
        },
        {
          text: '1.8. Зона обслуживания — территория, в пределах которой Услуги Партнеров могут быть оказаны Заказчику на условиях, определенных настоящим Договором.',
          margin: [0, 0, 0, 5],
        },
        {
          text: '1.9. Отчетный период — период в течение срока действия настоящего Договора, равный календарному месяцу. При этом первым Отчётным периодом признается период времени с даты вступления в силу настоящего Договора до окончания соответствующего календарного месяца, а последним Отчётным периодом — период времени с даты начала соответствующего календарного месяца до даты окончания срока действия или расторжения настоящего Договора.',
          margin: [0, 0, 0, 5],
        },
        {
          text: `1.10. ${request?.request_number} — это уникальный идентификатор Заказчика, который используется для единого суммарного учета оказанных МЕДИТ  Услуг по настоящему Договору, информации о платежах за Услуги и о задолженности Заказчика за оказание Услуг по Договору. ${request?.request_number}  носит технологический и информационный характер и не имеет статуса расчетного или банковского счета. ${request?.request_number} указывается в аккаунте Заказчика.`,
          margin: [0, 0, 0, 10],
        },
        {
          text: [
            '1.11. Сайт ',
            { text: '«Сервис temp03»', bold: true },
            ' — ресурс в сети Интернет, доступный по следующей ссылке: ',
            { text: 'https://temp03.ru', link: 'https://temp03.ru', color: 'blue', decoration: 'underline' }
          ],
          margin: [0, 0, 0, 10],
        },
        {
          text: '1.12. Тариф — система ставок оплаты за различные Услуги, доступные Заказчику в Личном кабинете, формируются при оформлении заказа на основании предложений от Партнёров Сервиса.',
          margin: [0, 0, 0, 10],
        },
        {
          text: [
            '1.13. Внесение денежных средств на счет — платеж Заказчика на расчетный счет ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' по счету, выставленному ООО «МЕДИТ ТЭМП03». Расчетный счет ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ` указывается в сформированных договорах и выставленных счетах на оплату. В назначении платежа Заказчик в обязательном порядке указывает номер ${request?.request_number} Заказчика. В случае различия между расчетным счетом `,
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ', указанным в реквизитах настоящего Договора, и расчетным счетом ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ', указанным в выставленных счетах, приоритет имеет расчетный счет ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ', указанный в выставленных счетах.'
          ],
          margin: [0, 0, 0, 5],
        },
        {
          text: [
            '1.14. Списание денежных средств — списание ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' денежных средств из платежей Заказчика в качестве предоплаты за предоставленные Услуги, осуществляемое в текущем режиме, а также Заказчик производит постоплату выставленных счетов ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' при активации в приложении для заказчика условия постоплаты.'
          ],
          margin: [0, 0, 0, 10],
        },
        {
          text: '1.15. Баланс счета — разность между двумя суммами денежных средств в определенный момент времени. Первая сумма состоит из денежных средств, внесенных на счет до данного момента времени оказания услуги; вторая сумма состоит из списанных денежных средств со счета по факту выполненных услуг.',
          margin: [0, 0, 0, 5],
        },
        {
          text: '1.18. Заказчик — индивидуальный предприниматель/юридическое лицо, зарегистрированное на территории Российской Федерации в установленном порядке, заключившее настоящий Договор посредством акцепта Оферты, в порядке, указанном в преамбуле настоящей Оферты.',
          margin: [0, 0, 0, 10],
        },
        {
          text: [
            '1.19. Стороны — совместное упоминание ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' и Заказчика по тексту Договора.'
          ],
          margin: [0, 0, 0, 5],
        },
        {
          text: [
            '1.20. Сторона — упоминание ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' или Заказчика по тексту Договора.'
          ],
          margin: [0, 0, 0, 10],
        },
        {
          text: 'В Договоре могут быть использованы иные термины, не определенные в разделе 1 Договора, толкование которых производится в соответствии с текстом Договора. В случае отсутствия однозначного толкования термина в тексте Договора следует руководствоваться толкованием термина: в первую очередь — определенным на Сервисе, во вторую очередь — сложившимся в сети Интернет.',
          margin: [0, 0, 0, 12],
        },
        {
          text: '2. Предмет Договора\n',
          style: 'sectionHeader',
          alignment: 'center',
          margin: [0, 20, 0, 16],
        },

        {
          text: [
            '2.1. В соответствии с настоящим Договором ',
            { text: 'ООО «МЕДИТ ТЭМП03»', bold: true },
            ' (далее по тексту - «Сервис temp03») обязуется организовать оказание от ',
            { text: 'Партнёров  Сервиса,  Пациенту', bold: true },
            ' (лицу в интересах, которого Заказчик заключил настоящий договор) на возмездной основе, через разовые медицинские и иные услуги, включающие консультации специалистов, диагностическое обследование (УЗИ лаборатория, КТ, МРТ и др.),  услуги скорой медицинской помощи, организацию госпитализации, подбор стационара в соответствии с диагнозом Пациента, организацию проведения стационарного лечения в специализированном лечебно-профилактическом учреждении (ЛПУ),  а Заказчик обязуется оплачивать стоимость предоставляемых услуг ',
            { text: 'выбранных им в приложении программы', bold: true },
            '«Сервис temp03», ',
            { text: 'путём привлечения ООО «МЕДИТ ТЭМП03»   лицензированных ', bold: true },
            'Партнёр Сервиса (-далее  Партнеры Сервиса), а именно Юридических лиц имеющих Лицензию на осуществление медицинской деятельности по оказанию услуг в указанной сфере ',
            { text: `( информация о Партнере представляется по факту оказания медицинской услуги, путём указания ИНН и Лицензии ${emergency_org?.inn} даты начала действия от ${emergency_org?.inn_date} г., кем выдана в соответствии с перечнем оказываемых медицинских услуг ). \n`, bold: true },
          ],
          margin: [0, 0, 0, 10],
        },
        {
          text: [
            '2.2. ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' обязуется в течение срока действия настоящего Договора оказывать Заказчику услуги, доступные для заказа с использованием «Сервис temp03» и выполнять поручения Заказчика по переводу приему денежных средств за оплату Услуг, на условиях и в порядке, определенных в настоящем Договоре и Условиях оказания услуг, размещенных в сети Интернет по адресу: ',
            { text: 'https://temp03.ru', link: 'https://temp03.ru', color: 'blue', decoration: 'underline' },
            ' (далее — «Услуги»).'
          ],
          margin: [0, 0, 0, 5],
        },
        {
          text: '2.3. Заказчик обязуется оплачивать оказываемые по настоящему Договору Услуги на условиях и в порядке, определенных в настоящем Договоре.',
          margin: [0, 0, 0, 10],
        },
        {
          text: [
            '2.4. В целях оказания ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' Услуг Заказчику по настоящему Договору, ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' без дополнительного письменного согласия Заказчика привлекает Партнеров Сервиса, осуществляющие оказание Услуг Партнеров в соответствии с законодательством Российской Федерации. ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' настоящим подтверждает, что условия договоров, заключаемых МЕДИТ с Партнерами, содержат обязательство последних осуществлять свою деятельность исключительно в соответствии с требованиями применимого законодательства Российской Федерации. Ответственность за ненадлежащее оказание Услуг Партнеров несут исключительно Партнеры, информация о которых предоставляется Заказчику по письменному мотивированному запросу в течение 3 (трех) рабочих дней с момента получения такого запроса МЕДИТОМ.'
          ],
          margin: [0, 0, 0, 10],
        },
        {
          text: '2.5. Стороны пришли к соглашению о том, что необходимый объем Услуг Партнеров определяется Корпоративными Пользователями и/или уполномоченными представителями Заказчика самостоятельно и подлежит оплате Заказчиком в полном объеме, указанном в соответствующем одностороннем Акте об оказанных услугах, оформляемом в соответствии с разделом 5 настоящего Договора (далее — «Акт»).',
          margin: [0, 0, 0, 10],
        },
        {
          text: '3. Права и обязанности МЕДИТ ТЭМП03\n',
          style: 'sectionHeader',
          alignment: 'center',
          margin: [0, 20, 0, 16],
        },
        {
          text: [
            '3.1. ',
            { text: 'Сервис МЕДИТ ТЭМП03 обязуется:\n', bold: true },
          ],
          margin: [0, 0, 0, 5],
        },
        {
          text: '3.1.1. Оказывать Заказчику Услуги, предусмотренные настоящим Договором, в соответствии условиями настоящего Договора. Настоящее обязательство является встречным по отношению к обязательству Заказчика, указанному в п. 4.1.4. Договора.',
          margin: [0, 0, 0, 5],
        },
        {
          text: '3.1.2. Направлять Заказчику Акт и счет-фактуру в порядке, предусмотренном в разделе 5 настоящего Договора.',
          margin: [0, 0, 0, 5],
        },
        {
          text: [
            '3.1.3. При оказании Услуг по Договору обеспечить возможность ознакомления Заказчика с Данными статистики через Личный кабинет, при этом ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' («Сервис temp03») не несет ответственности в случае невозможности ознакомления Заказчика с Данными статистики по причинам, не зависящим от ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            '.'
          ],
          margin: [0, 0, 0, 10],
        },
        {
          text: '3.1.4. В случае поступления от Корпоративных Пользователей и/или уполномоченных представителей Заказчика мотивированных жалоб в части оказания Партнерами Услуг Партнеров, рассмотреть такие жалобы и оказать содействие по урегулированию возникших разногласий между Заказчиком и Партнером.',
          margin: [0, 0, 0, 5],
        },
        {
          text: '3.1.5. Организовать оказание качественной и своевременной медицинской помощи.',
          margin: [0, 0, 0, 5],
        },
        {
          text: '3.1.6. Предоставить бригаду скорой медицинской помощи для осуществления медицинского сопровождения на мероприятии, согласно п. 1.1. настоящего договора.',
          margin: [0, 0, 0, 5],
        },
        {
          text: '3.1.7. Вызывать «на себя» бригаду государственной службы скорой медицинской помощи при необходимости госпитализации пациента по жизненным показаниям, обратившегося во время проведения мероприятия. В случае отказа государственной службой скорой медицинской помощи в приёме вызова — госпитализировать пострадавшего в стационар своими силами, в рамках оплаченного времени дежурства. При завершении оплаченного времени дежурства дополнительно выставить счёт Заказчику на оплату оказанных услуг скорой медицинской помощи из расчёта стоимости 1 часа дежурства, указанного в приложении.',
          margin: [0, 0, 0, 5],
        },
        {
          text: '3.1.8. Вести учёт видов, объёмов, стоимости оказанных медицинских услуг, а также денежных средств, поступивших от Заказчика.',
          margin: [0, 0, 0, 5],
        },
        {
          text: '3.1.9. После оказания услуги предоставить Заказчику на утверждение Акт сдачи-приемки услуг в течение 5 (пяти) дней после завершения мероприятия по каждой заявке. Заказчик подписывает данный акт или направляет мотивированный отказ от его подписания в течение 5 (пяти) дней после получения его от Исполнителя.',
          margin: [0, 0, 0, 5],
        },
        {
          text: '3.1.10. Поставить в известность Заказчика о возникших обстоятельствах, которые могут привести к невозможности оказания медицинской помощи.',
          margin: [0, 0, 0, 5],
        },
        {
          text: '3.1.11. Обеспечивать круглосуточную работу телефона своей диспетчерской службы.',
          margin: [0, 0, 0, 5],
        },
        {
          text: '3.1.12. Выполнять надлежащим образом обязательства, принятые по настоящему договору.',
          margin: [0, 0, 0, 10],
        },
        {
          text: [
            { text: '3.2 Сервис МЕДИТ ТЭМП03 имеет право:', bold: true }
          ],
          margin: [0, 0, 0, 5],
        },
        {
          text: '3.2.1. Требовать от Заказчика выполнения обязательств, взятых на себя согласно настоящему Договору.',
          margin: [0, 0, 0, 5],
        },
        {
          text: '3.2.2. При отсутствии информации о продлении времени нахождения бригады скорой медицинской помощи на дежурстве и соответствующей доплаты бригада СМП Исполнителя снимается с дежурства не позднее 15 мин после истечения времени, указанного в п.1.1, без уведомления контактного лица Заказчика.',
          margin: [0, 0, 0, 5],
        },
        {
          text: [
            '3.2.3. Вносить изменения в Тарифы путем опубликования их в новой редакции в Личном кабинете. Указанные изменения вступают в силу в момент их опубликования. ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' вправе уведомлять Заказчика о таких изменениях.'
          ],
          margin: [0, 0, 0, 5],
        },
        {
          text: [
            '3.2.4. Получать от Заказчика денежные суммы в счет оплаты Услуг, оказываемых ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ', по настоящему Договору, в порядке и на условиях, определённых настоящим Договором.'
          ],
          margin: [0, 0, 0, 5],
        },
        {
          text: [
            '3.2.5. Приостановить оказание Услуг, в случае наличия у Заказчика задолженности перед ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' по настоящему Договору.'
          ],
          margin: [0, 0, 0, 5],
        },
        {
          text: '3.2.6. Уведомлять Заказчика по электронной почте о подозрениях в отношении того, что Услугами Партнеров от имени Заказчика пользуются третьи лица, не признаваемые Корпоративными Пользователями в соответствии с настоящим Договором.',
          margin: [0, 0, 0, 10],
        },

        {
          text: '4. Права и обязанности Заказчика\n',
          style: 'sectionHeader',
          alignment: 'center',
          margin: [0, 20, 0, 16],
        },
        {
          text: [
            '4.1.1. Заказчик оплачивает Сервису ',
            { text: 'temp03', bold: true },
            ' стоимость оказанных медицинских услуг. Оплата осуществляется в соответствии с раздела 5 настоящего договора и на основании действующих Тарифов на медицинские услуги, утвержденных ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' и согласованных с Заказчиком (Заявка № 1).'
          ],
          margin: [0, 0, 0, 5],
        },
        {
          text: [
            '4.1.2. Производить платежи ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' за оказанные медицинские услуги своевременно, в установленные настоящим Договором сроки.'
          ],
          margin: [0, 0, 0, 5],
        },
        {
          text: [
            '4.1.3. На время проведения мероприятия Заказчик предоставляет ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' контактное лицо, координирующее действия бригады скорой помощи и в случае необходимости принимающее решение об изменении времени нахождения на дежурстве СМП ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ', уведомляя об этом через ',
            { text: 'Сервис temp03', bold: true },
            ', через телефон связи с Диспетчером Сервиса либо ',
            { text: 'передает информацию ответственному', bold: true },
            ' бригады, но не позднее 1 часа до истечения времени, указанного в сформированной заявке. По факту завершения дежурства контактное лицо Заказчика подписывает все необходимые отчетные документы. При продлении времени дежурства, заказчик должен согласовать через диспетчерский пульт ',
            { text: '8 800 5503500', bold: true },
            ' длительность продления времени дежурства и прислать гарантийное письмо об оплате.'
          ],
          margin: [0, 0, 0, 5],
        },
        {
          text: '4.1.4. Обязуется создать для бригады скорой медицинской помощи условия, гарантирующие безопасность для их здоровья и жизни, в том числе доступ к санитарным комнатам (сан.узел).',
          margin: [0, 0, 0, 5],
        },
        {
          text: '4.1.5. Гарантирует сохранность и целостность оборудования бригады скорой помощи. В случае поломки оборудования по вине организаторов мероприятия, обязуется оплатить стоимость причиненного ущерба согласно балансовой стоимости оборудования или расходов по его ремонту, а также расходы, связанные с экспертизой неисправного оборудования.',
          margin: [0, 0, 0, 5],
        },
        {
          text: '4.1.6. При продолжительности дежурства на мероприятии более 6 (шести) часов, обеспечить бригаду скорой медицинской помощи помещением для приема пищи продолжительностью до 45 минут.',
          margin: [0, 0, 0, 5],
        },
        {
          text: [
            '4.1.7. По завершению дежурства оставить отзыв в приложении ',
            { text: 'Сервисa temp03', bold: true },
            ' или связаться с Диспетчерским пультом исполнителя по телефонам ',
            { text: '8 800 550 3500', bold: true },
            ' / и сообщить о качестве выполненного дежурства.'
          ],
          margin: [0, 0, 0, 5],
        },
        {
          text: '4.1.8. Обязуется оплатить дополнительное время оказания услуг скорой медицинской помощи или дополнительно вызванную бригаду скорой помощи исполнителя в случае, указанном в разделе 5 (кроме бригад государственной службы скорой медицинской помощи), из расчета стоимости 1 часа дежурства, указанного в приложении.',
          margin: [0, 0, 0, 5],
        },
        {
          text: '4.1.9. Назначить со своей стороны лиц, ответственных за оперативное взаимодействие по вопросам исполнения Договора в течение срока действия Договора.',
          margin: [0, 0, 0, 10],
        },
        {
          text: [
            '4.1.10. До начала оказания ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' Услуг по Договору в Личном кабинете указать номера мобильных телефонов и ФИО Корпоративных Пользователей, а также иную информацию, необходимую для оказания Услуг по Договору. При этом Заказчик заверяет, что предоставление Заказчиком такой информации, содержание информации, и использование информации ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' в соответствии с условиями Договора не нарушает права третьих лиц, нормы действующего законодательства, включая законодательство о персональных данных, не обременено правами третьих лиц, не повлечет у ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' обязательств по выплате вознаграждения третьим лицам.'
          ],
          margin: [0, 0, 0, 5],
        },
        {
          text: '4.1.11. Поддерживать перечень Корпоративных Пользователей, а также информацию о таких Корпоративных Пользователях, указанную в Личном кабинете в актуальном состоянии на протяжении всего срока действия Договора. Для целей настоящего Договора Пользователь считается Корпоративным Пользователем до тех пор, пока информация о таком Пользователе указана в Личном кабинете. Заказчик обязуется самостоятельно обеспечить недопущение размещения запросов лицами, не являющимися Корпоративными Пользователями.',
          margin: [0, 0, 0, 5],
        },
        {
          text: [
            '4.1.12. Принимать Услуги ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ', оказанные в соответствии с настоящим Договором, в порядке и на условиях, предусмотренных Договором, и оплачивать Услуги ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' в порядке и в сроки, предусмотренные разделом 6 Договора.'
          ],
          margin: [0, 0, 0, 10],
        },
        {
          text: [
            '4.1.13. Проинформировать Корпоративных Пользователей об Условиях оказания услуг, размещенных в сети интернет по адресу: ',
            { text: 'https://temp03.ru', link: 'https://temp03.ru', color: 'blue', decoration: 'underline' },
            ', о Тарифах, а также доводить до сведения Корпоративных пользователей всю иную получаемую от ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' информацию об Услугах Партнеров Сервиса.'
          ],
          margin: [0, 0, 0, 5],
        },
        {
          text: [
            '4.1.14. Если информация, указанная в п. 4.1.10., 4.1.11. Договора, содержит персональные данные, Заказчик обязуется получать предусмотренные законом разрешения (согласия) Корпоративных Пользователей на передачу их персональных данных ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ', а также на их обработку ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' в целях и способами, необходимыми для исполнения обязательств по Договору, на срок действия Договора и 5 (пяти) лет после его прекращения, а также хранить указанные согласия в течение указанного срока и предоставлять их ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' по его требованию. В случае прекращения правовых оснований у Заказчика на обработку персональных данных Корпоративного Пользователя (включая отзыв согласия), Заказчик обязан в течение трех рабочих дней сообщить об этом ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            '.'
          ],
          margin: [0, 0, 0, 5],
        },
        {
          text: [
            '4.1.15. В течение 1 (одного) рабочего дня отвечать ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' на уведомления, направленные в соответствии настоящего Договора.'
          ],
          margin: [0, 0, 0, 10],
        },
        {
          text: '5.4. Заказчик имеет право:\n',
          style: 'sectionHeader',
          alignment: 'center',
          margin: [0, 20, 0, 16],
        },
        {
          text: '5.4.1. Требовать от Исполнителя надлежащего выполнения принятых им обязательств по настоящему Договору.',
          margin: [0, 0, 0, 5],
        },
        {
          text: '5.2.1. Получить доступ к Данным статистики при использовании Личного кабинета.',
          margin: [0, 0, 0, 5],
        },
        {
          text: [
            '5.2.2. Направлять ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' мотивированную жалобу по факту оказания Партнерами Сервиса Услуг ненадлежащего качества до конца Отчетного периода, в котором были оказаны соответствующие Услуги Партнеров. В случае признания (удовлетворения) ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' такой жалобы, стоимость Услуг, оказанных ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' за указанный Отчетный период, может быть пересмотрена Сторонами в сторону уменьшения.\n\n',
            'В случае направления мотивированной жалобы по истечении Отчетного периода (но не более 15 (пятнадцати) календарных дней с момента окончания Отчетного периода) и последующего признания (удовлетворения) ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' такой жалобы, Стороны пришли к соглашению о том, что сумма, на которую подлежит уменьшение стоимость Услуг ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ', признанная ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' по результатам рассмотрения жалобы, будет учитываться при определении стоимости Услуг ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' в Отчетном периоде, в котором такая жалоба была признана (удовлетворена) ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            '.\n\n',
            'Кроме того, Стороны пришли к соглашению, что прямой доказанный ущерб, с учетом ограничений, предусмотренных п. 7.3. Договора, может быть возмещен ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' Заказчику путем перечисления денежных средств на расчетный счет Заказчика на основании выставленного Заказчиком счета. ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' обязуется произвести выплату в течение 30 календарных дней с даты получения копии счета, при условии признания ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' такой мотивированной жалобы.'
          ],
          margin: [0, 0, 0, 10],
        },
        {
          text: '6. Размер и порядок оплаты\n',
          style: 'sectionHeader',
          alignment: 'center',
          margin: [0, 20, 0, 16],
        },
        {
          text: [
            { text: '6.1. ', bold: true },
            { text: 'Стоимость медицинских услуг Название услуги по факту: ' }, {text: `${request?.invoice[0].text}, `, bold: true}, 'по настоящему Договору составляет рублей ',
            {text: `${totalSum} `, bold: true}, { text: `(${convertNumberToWordsRu(totalSum)}) без НДС. `, bold: true, margin: [0, 0, 0, 20] },
            "Не облагается НДС на основании ст. 149 пп.2 п.2 Налогового кодекса Российской Федерации. ",
            {text: `Подробно ознакомиться с порядком оказания выбранной услуги возможно в разделе Условия и Правила платформы Сервиса temp03, `, bold: true},
            { text: 'https://customer.temp03.ru/terms-and-rules', link: 'https://customer.temp03.ru/terms-and-rules.', color: 'blue', decoration: 'underline' },
          ],
          style: 'normal',
          margin: [0, 0, 0, 20]
        },
        {
          table: {
            headerRows: 1,
            widths: [30, '*', 70, 60, 60, 60],
            body: [
              [
                { text: '№', style: 'tableHeader', alignment: 'center' },
                { text: 'Наименование услуги', style: 'tableHeader', alignment: 'center' },
                { text: 'Количество', style: 'tableHeader', alignment: 'center' },
                { text: 'Ед.', style: 'tableHeader', alignment: 'center' },
                { text: 'Цена', style: 'tableHeader', alignment: 'center' },
                { text: 'Сумма', style: 'tableHeader', alignment: 'center' }
              ],
              ...request?.invoice.map((item, index) => [
                { text: `${index + 1}`, border: [true, true, true, true] },
                { text: item.text, border: [true, true, true, true] },
                { text: item.qty, border: [true, true, true, true] },
                { text: item.eta, border: [true, true, true, true] },
                { text: item.price, border: [true, true, true, true] },
                { text: item.total, border: [true, true, true, true] }
              ])
            ]
          },
          layout: {
            hLineWidth: () => 0.5,
            vLineWidth: () => 0.5
          },
          margin: [0, 10, 0, 20]
        },
        {
          columns: [
            {
              width: '60%',
              text: '',
              margin: [0, 0, 0, 0]
            },
            {
              width: '40%',
              columns: [
                {
                  width: '50%',
                  stack: [
                    {
                      text: `Итого: `,
                      style: 'bold',
                      margin: [0, 0, 0, 0]
                    },
                    {
                      text: 'Без налога (НДС)',
                      style: 'bold',
                      margin: [0, 0, 0, 0]
                    },
                  ]
                },
                {
                  width: '50%',
                  stack: [
                    {
                      text: `${totalSum.toFixed(2)}`,
                      style: 'bold',
                      alignment: 'right',
                      margin: [0, 0, 0, 0]
                    },
                    {
                      text: '-',
                      style: 'bold',
                      alignment: 'right',
                      margin: [0, 0, 0, 0]
                    },
                  ]
                }
              ]
            }
          ]
        },
        { text: `\nВсего наименований ${request?.invoice.length}, на сумму: ${totalSum.toFixed(2)} руб.`, margin: [0, 0, 0, 0] },
        { text: `(Сумма прописью) ${convertNumberToWordsRu(totalSum)}`, style: "bold", margin: [0, 0, 0, 20] },
        {
          text: '6.2. Счет должен содержать все необходимые реквизиты для перечисления денег.',
          margin: [0, 0, 0, 5],
        },
        {
          text: '6.3. Расчеты между Сторонами ведутся в безналичном или наличном порядке, в рублях.',
          margin: [0, 0, 0, 5],
        },
        {
          text: '6.4. Заказчик обязан в течение 5-и банковских дней со дня получения счета перечислить на счет или внести в кассу Исполнителя деньги, при этом фактическое поступление денег на счет Исполнителя должно произойти до момента оказания услуг Исполнителем.',
          margin: [0, 0, 0, 5],
        },
        {
          text: [
            '6.5. Стоимость Услуг ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' рассчитывается на основании Данных статистики, доступных Заказчику в Личном кабинете, по применимым Тарифам, предложенными Партнёрами Сервиса и согласованными с Заказчиком. На стоимость Услуг ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ', кроме медицинских услуг, рассчитанных в указанном порядке, может начисляться НДС по ставке, предусмотренной Налоговым кодексом РФ.'
          ],
          margin: [0, 0, 0, 5],
        },
        {
          text: [
            '6.6. Оплата Услуг осуществляется авансом путем Внесения денежных средств на счет ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            '.'
          ],
          margin: [0, 0, 0, 5],
        },
        {
          text: '6.7. Минимальный первоначальный платеж по Договору согласуется в теле договора.',
          margin: [0, 0, 0, 5],
        },
        {
          text: [
            '6.8. Взимание оплаты за Услуги производится путем выставления счета на предоплату услуг в сумме, рассчитанной в соответствии с п. 6.1. Договора.'
          ],
          margin: [0, 0, 0, 10],
        },
        {
          text: [
            '6.9. ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' вправе предоставить Заказчику возможность заказа Услуг на условиях отсрочки платежа, т.е. право Заказчика на получение Услуг при отрицательном Балансе Лицевого счета посредством изменения Порога отключения. ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' обязуется уведомить Заказчика о возникновении у последнего данной возможности путем направления на адрес электронной почты соответствующего письма либо путем уведомления в Личном кабинете с указанием даты начала возможности применения вышеуказанной возможности, максимальной суммы оказания Услуг ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' на условиях отсрочки платежа (нового размера Порога отключения) и иных условий заказа Услуг при отрицательном Балансе Лицевого счета Заказчика. В этом случае, если Баланс Лицевого счета составляет сумму меньше обновленного Порога отключения, ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' имеет право прекратить оказывать Услуги Заказчику на условиях отсрочки платежа. Возобновление действия права Заказчика заказывать Услуги на условиях отсрочки платежа осуществляется при условии Внесения денежных средств на Лицевой счет в сумме не менее 100% (ста процентов) от стоимости заказанных, но не оплаченных Заказчиком Услуг, при этом Баланс Лицевого счета после пополнения должен быть не менее Порога отключения.'
          ],
          margin: [0, 0, 0, 8],
        },
        {
          text: [
            '6.10. Заказчик обязуется производить оплату Услуг ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ', оказанных на условиях отсрочки платежа, как предусмотрено п. 6.6. Договора, не позднее 15 (пятнадцати) календарных дней с момента окончания Отчетного периода, в котором указанные Услуги были оказаны, путем внесения денежных средств на расчетный счет ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ', с обязательным указанием номера Лицевого счета. Тем не менее, ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' вправе в любой момент потребовать оплаты оказанных Заказчику Услуг, а Заказчик обязан удовлетворить указанное требование в течение 5 (пяти) рабочих дней с момента его направления.'
          ],
          margin: [0, 0, 0, 8],
        },
        {
          text: [
            '6.11. Стороны признают, что для целей настоящего Договора, в частности, для определения объема оказанных ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' Услуг и их стоимости используются исключительно Данные статистики, отраженные в Личном кабинете.'
          ],
          margin: [0, 0, 0, 8],
        },
        {
          text: [
            '6.12. Обязательства Заказчика по оплате Услуг в порядке, предусмотренным настоящим Договором, считаются исполненными с момента поступления денежных средств на соответствующий корреспондентский счет банка ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            '.'
          ],
          margin: [0, 0, 0, 10],
        },
        {
          text: '7. Порядок сдачи-приемки Услуг\n',
          style: 'sectionHeader',
          alignment: 'center',
          margin: [0, 20, 0, 16],
        },
        {
          text: [
            '7.1. В течение срока действия настоящего Договора ежемесячно, в течение 7 (семи) рабочих дней с момента окончания Отчетного периода, ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' направляет Заказчику односторонний Акт в соответствии с объемом фактически оказанных в Отчетном периоде Услуг и счет-фактуру с учетом корректировок, которые могут быть осуществлены в соответствии с п. 4.2.2. Договора.'
          ],
          margin: [0, 0, 0, 5],
        },
        {
          text: [
            '7.2. Акт и счет-фактура направляются ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' Заказчику по почте, с одновременным направлением копии текста Акта и счета-фактуры по электронной почте. Стороны признают, что копия текста Акта, направленная ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' Заказчику по электронной почте, будет применяться Заказчиком в процессе приемки Услуг, оказанных МЕДИТом, до момента получения оригинала Акта.'
          ],
          margin: [0, 0, 0, 5],
        },
        {
          text: [
            '7.3. Датой получения копии текста Акта, направленного ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' Заказчику по электронной почте, считается следующий рабочий день за днем отправки.'
          ],
          margin: [0, 0, 0, 5],
        },
        {
          text: [
            '7.4. Стороны установили, что Услуги ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' считаются оказанными надлежащим образом и принятыми Заказчиком в указанном в Акте объеме, если в течение 13 (тринадцати) календарных дней с даты Акта ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' не получил от Заказчика мотивированный письменный отказ от Акта. По истечении срока, указанного выше, претензии относительно недостатков Услуг, оказанных ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' и/или Партнерами Сервиса, в том числе по количеству (объему), стоимости и качеству не принимаются.'
          ],
          margin: [0, 0, 0, 10],
        },
        {
          text: '8. Ответственность Сторон\n',
          style: 'sectionHeader',
          alignment: 'center',
          margin: [0, 20, 0, 16],
        },
        {
          text: '8.1. За нарушение предусмотренных Договором обязательств Стороны несут ответственность в соответствии с действующим законодательством РФ.',
          margin: [0, 0, 0, 5],
        },
        {
          text: [
            '8.2. В случае нарушения Заказчиком сроков оплаты Услуг, оказываемых ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' по настоящему Договору, ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' вправе потребовать уплаты штрафной неустойки в размере 0,2% (две десятых процента) от суммы просроченного платежа за каждый день просрочки, но не более 10% от суммы основного платежа. Уплата пени не освобождает Заказчика от осуществления основного платежа.'
          ],
          margin: [0, 0, 0, 5],
        },
        {
          text: [
            '8.3. Совокупная ответственность ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' по Договору ограничивается возмещением Заказчику прямого доказанного ущерба.'
          ],
          margin: [0, 0, 0, 5],
        },
        {
          text: [
            '8.4. Положения настоящего раздела не применяются к отношениям Сторон, урегулированным Условиями оказания услуг корпоративным клиентам сервиса ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' «Сервис temp03», являющихся неотъемлемой частью настоящей Оферты, доступных в сети Интернет по адресу: ',
            { text: 'https://temp03.ru', link: 'https://temp03.ru', color: 'blue', decoration: 'underline' },
            ' и содержащих положения, устанавливающие меры ответственности Сторон.'
          ],
          margin: [0, 0, 0, 5],
        },
        {
          text: '8.5. Стороны могут предъявлять взаимные претензии по факту нарушений, связанных с исполнением настоящего Договора, в течение всего срока действия Договора. При наличии претензий и при согласии с ними, виновная сторона должна в 3-х-дневный срок представить объяснения, исправить упущения и учесть в последующей работе требования, содержащиеся в претензии. В случае несогласия с предъявленными претензиями, Сторона, к которой такие претензии предъявляются, вправе обратиться за разрешением спора в согласительную комиссию.',
          margin: [0, 0, 0, 5],
        },
        {
          text: '8.6. Ни одна из Сторон не будет нести ответственность за полное или частичное неисполнение любой из своих обязанностей, если докажет, что надлежащее исполнение оказалось невозможным вследствие действия непреодолимой силы, то есть чрезвычайных и непредотвратимых при данных условиях обстоятельств. К таким обстоятельствам не относятся, в частности, нарушение обязанностей со стороны контрагентов должника, отсутствие нужных для исполнения материалов, отсутствие у должника необходимых денежных средств.',
          margin: [0, 0, 0, 5],
        },
        {
          text: '8.7. Срок исполнения обязательств по настоящему Договору отодвигается соразмерно времени действия обстоятельств непреодолимой силы.',
          margin: [0, 0, 0, 5],
        },
        {
          text: '8.8. Сторона, для которой создалась невозможность исполнения обязательства, обязана немедленно известить другую Сторону о наступлении, предполагаемом сроке действия и прекращения вышеуказанных обстоятельств.',
          margin: [0, 0, 0, 5],
        },
        {
          text: '8.9. Действие данных обстоятельств должно быть подтверждено документально соответствующей компетентной организацией или государственным органом.',
          margin: [0, 0, 0, 5],
        },
        {
          text: '8.10. Стороны освобождаются от ответственности за неисполнение и/или ненадлежащие исполнение обязательств по настоящему Договору, если такое неисполнение явилось следствием обстоятельств непреодолимой силы (форс-мажор), не зависящих от воли Сторон, к которым, среди прочих, относятся стихийные бедствия, пожары, техногенные аварии и катастрофы, аварии на инженерных сооружениях и коммуникациях, массовые беспорядки, военные действия, террористические акты, бунты, гражданские волнения, забастовки, нормативные акты органов государственной власти и местного самоуправления, препятствующие исполнению Сторонами своих обязательств по настоящему Договору, то есть чрезвычайные и непреодолимые при данных условиях обстоятельства, наступившие после заключения настоящего Договора. Сторона, ссылающаяся на невозможность выполнения обязательств вследствие наступления обстоятельств непреодолимой силы, обязана незамедлительно уведомить об этом другую Сторону. Факт наступления обстоятельств непреодолимой силы должен быть подтвержден соответствующими компетентными организациями.',
          margin: [0, 0, 0, 10],
        },
        {
          text: ' 9. Контроль.\n',
          style: 'sectionHeader',
          alignment: 'center',
          margin: [0, 20, 0, 16],
        },
        {
          text: '9.1. Заказчик контролирует соответствие оказываемых Исполнителем медицинских услуг требованиям настоящего Договора.',
          margin: [0, 0, 0, 5],
        },
        {
          text: '9.2. Контроль осуществляется путем проверок, проводимых представителем Заказчика. Проверка осуществляется по мере необходимости. Результаты проверок доводятся Заказчиком до сведения Исполнителя.',
          margin: [0, 0, 0, 5],
        },
        {
          text: '9.3. Исполнитель обязан обеспечить представителю Заказчика, осуществляющему проверку, свободное ознакомление с деятельностью Исполнителя, связанной с выполнением данного Договора. Проверку медицинской деятельности, связанной с выполнением данного Договора, может осуществлять только представитель Заказчика, имеющий высшее медицинское образование.',
          margin: [0, 0, 0, 5],
        },
        {
          text: '9.4. При несогласии Исполнителя с выводами представителя Заказчика, он вправе обратиться за разрешением спора в согласительную комиссию.',
          margin: [0, 0, 0, 5],
        },
        {
          text: '9.5. Согласительная комиссия создается из представителей Исполнителя и Заказчика, при необходимости с привлечением независимого эксперта. Расходы по оплате работы независимого эксперта ложатся на Исполнителя, если претензии Заказчика признаны Согласительной комиссией правомерными. В противном случае расходы несет Заказчик.',
          margin: [0, 0, 0, 5],
        },
        {
          text: '9.6. Решение комиссии является обязательным к исполнению каждой Стороной.',
          margin: [0, 0, 0, 10],
        },
        {
          text: '10. Уведомления и сообщения.\n',
          style: 'sectionHeader',
          alignment: 'center',
          margin: [0, 20, 0, 16],
        },
        {
          text: '10.1. Все уведомления и сообщения, направляемые сторонами в связи с исполнением настоящего Договора, должны быть сделаны в письменной форме.',
          margin: [0, 0, 0, 5],
        },
        {
          text: '10.2. Стороны обязуются в трехдневный срок извещать друг друга об изменении своих адресов или реквизитов.',
          margin: [0, 0, 0, 5],
        },
        {
          text: [
            '10.3. ',
            { text: 'Для получения оперативной информации об исполнении Заявки по вызову СМП звонить по телефону:', bold: true },
            ' 8 800 550 3 500, ',
            { text: 'в части расчетов', bold: true },
            ' ',
            { text: 'info@mail.temp03.ru', link: 'mailto:info@mail.temp03.ru', color: 'blue', decoration: 'underline' },
            '.'
          ],
          margin: [0, 0, 0, 5],
        },
        {
          text: '10.4. Настоящий Договор вступает в силу с момента подписания сторонами и действует до момента исполнения сторонами обязательств по настоящему Договору, что подтверждается подписанием Акта сдачи-приемки услуг.',
          margin: [0, 0, 0, 5],
        },
        {
          text: '10.5. Условия Договора могут быть изменены или дополнены в связи с принятием законодательных актов или по предложению одной из сторон. Предложения сторон об изменении или дополнении условий Договора рассматриваются в течение 2 дня с момента поступления. Изменения и дополнения к настоящему Договору будут считаться имеющими силу, если они выполнены в письменной форме и подписаны обеими сторонами.',
          margin: [0, 0, 0, 5],
        },
        {
          text: [
            '10.6. Настоящий Договор может быть прекращен до окончания срока его действия:\n',
            'а) по обоюдному Согласию сторон, оформленному в виде Соглашения и подписанному Заказчиком и Исполнителем;\n',
            'б) одной из Сторон настоящего Договора в одностороннем порядке:\n',
            '- при письменном уведомлении другой Стороны о намерении расторгнуть Договор не менее чем за 5 дней до предполагаемой даты расторжения;\n',
            '- в случае прекращения деятельности, указанной в настоящем Договоре, ликвидации или реорганизации одной из сторон, при этом за другой стороной сохраняется право требовать возмещения убытков;\n',
            '- в случае существенного нарушения условий данного Договора одной из сторон и невозможности ликвидировать отрицательные последствия такого нарушения иным, нежели расторжение Договора, путем;\n',
            '- при наступлении обстоятельств, перечисленных в п.5.3. настоящего Договора.'
          ],
          margin: [0, 0, 0, 5],
        },
        {
          text: '10.7. Прекращение настоящего Договора освобождает стороны от исполнения обязательств по Договору только после того, как они выполнят свои обязательства, возникшие у них до прекращения настоящего Договора, в полном объеме.',
          margin: [0, 0, 0, 10],
        },
        {
          text: '11. Срок действия Договора. Порядок расторжения и изменения Договора\n',
          style: 'sectionHeader',
          alignment: 'center',
          margin: [0, 20, 0, 16],
        },
        {
          text: `11.1 ${contractStart} ${contractEnd}\n\n`,
          margin: [0, 0, 0, 5],
        },
        {
          text: '11.2. Настоящий Договор вступает в силу с момента подписания сторонами и действует до момент исполнения сторонами обязательств по настоящему Договору. Прекращение настоящего Договора освобождает стороны от исполнения обязательств по Договору только после того, как они выполнят свои обязательства, возникшие у них до прекращения настоящего Договора, в полном объеме. Что подтверждается подписанием Акта сдачи-приемки услуг.',
          margin: [0, 0, 0, 5],
        },
        {
          text: '11.3. Обязательства Сторон по Договору, которые в силу своей природы должны продолжать действовать (включая, но не ограничиваясь, обязательства в отношении проведения взаиморасчетов), остаются в силе после окончания срока действия Договора.',
          margin: [0, 0, 0, 5],
        },
        {
          text: '12. Персональные данные\n',
          style: 'sectionHeader',
          alignment: 'center',
          margin: [0, 20, 0, 16],
        },
        {
          text: '12.1. Каждая из Сторон является оператором персональных данных, в том числе обрабатываемых в рамках выполнения обязательств, предусмотренных Договором. Для целей Договора под персональными данными понимаются сведения, являющиеся таковыми в соответствии с законодательством Российской Федерации и относящиеся к работникам, иным представителям Сторон, в том числе — непосредственно участвующим в исполнении Договора, и третьим лицам, данные которых передаются другой Стороне.',
          margin: [0, 0, 0, 5],
        },
        {
          text: '12.2. Передача персональных данных не рассматривается Сторонами как поручение обработки персональных данных.',
          margin: [0, 0, 0, 5],
        },
        {
          text: '12.3. Каждая из Сторон обеспечивает конфиденциальность полученных в рамках Договора персональных данных от другой Стороны, соблюдение требований к обработке персональных данных, установленных Федеральным законом № 152-ФЗ от 27.07.2006 «О персональных данных» и принятыми в его исполнение нормативными правовыми актами, и несет ответственность за принятие всех необходимых правовых, организационных и технических мер защиты персональных данных от неправомерного или случайного доступа к ним, уничтожения, изменения, блокирования, копирования, распространения персональных данных, а также от иных неправомерных действий с такими данными.',
          margin: [0, 0, 0, 5],
        },
        {
          text: '12.4. Ответственность за правомерность и достоверность персональных данных, предоставляемых Сторонами друг другу в целях исполнения Договора, а также за получение согласия субъектов на передачу их персональных данных другой Стороне в порядке, предусмотренном законодательством Российской Федерации, несет Сторона, передающая персональные данные.',
          margin: [0, 0, 0, 5],
        },
        {
          text: '12.5. Сторона, получившая персональные данные от другой Стороны, не принимает на себя обязательства по информированию субъектов, персональные данные которых ей переданы, о начале их обработки, поскольку обязанность осуществить соответствующее информирование при получении согласия на такую передачу несет передавшая персональные данные Сторона.',
          margin: [0, 0, 0, 5],
        },
        {
          text: '12.6. Сторона, получающая персональные данные, имеет право в целях исполнения Договора в необходимом для этого объеме привлекать к обработке полученных персональных данных аффилированных с такой Стороной лиц, либо компании, входящие в одну группу лиц с такой Стороной.',
          margin: [0, 0, 0, 5],
        },
        {
          text: [
            '12.7. При этом Стороны признают, что Услуги, оказываемые ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' по настоящему Договору, не могут быть оказаны в отношении Корпоративных Пользователей, которые не предоставили или отозвали свое согласие на обработку их персональных данных в порядке, предусмотренном законодательством РФ.'
          ],
          margin: [0, 0, 0, 5],
        },
        {
          text: [
            '12.8. ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' осуществляет запись телефонных звонков с Пользователями в целях контроля качества и улучшения сервиса. Пользователь согласен на передачу записей телефонных звонков с Пользователем ',
            { text: 'МЕДИТ', bold: true },
            ' в сторону ',
            { text: 'ООО «МЕДИТ ТЭМП03» 119296, г. Москва,  Ломоносовский пр-т, д. 18,   этаж 1 пом XXIX ком 1-5 ИНН 7736314094', bold: true },
            '. Состав персональных данных: голосовые записи телефонных звонков с Пользователем, любая иная информация, озвученная в ходе телефонных звонков, если она относится к персональным данным. Способы обработки: сбор, запись, систематизация, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, передача (предоставление, доступ), обезличивание, блокирование, удаление, уничтожение с использованием средств автоматизации или без использования таких средств. Пользователь заверяет ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' об обстоятельстве, имеющем значение для исполнения Договора, что получил необходимое согласие на передачу персональных данных третьих лиц ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' в ходе телефонных звонков. ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' может предупреждать о записи телефонных звонков (в случае ее ведения) при каждом контакте с Пользователем. Персональные данные, содержащиеся в записях телефонных звонков, обрабатываются ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' на условиях Политики конфиденциальности ',
            { text: 'https://temp03.ru', link: 'https://temp03.ru', color: 'blue', decoration: 'underline' },
            '.'
          ],
          margin: [0, 0, 0, 10],
        },
        {
          text: '13. Правила корпоративной этики\n',
          style: 'sectionHeader',
          alignment: 'center',
          margin: [0, 20, 0, 16],
        },
        {
          text: [
            'Стороны соблюдают все применимые нормы антикоррупционного законодательства. Стороны признают и подтверждают, что каждая из них проводит политику полной нетерпимости к взяточничеству и коррупции, предполагающую полный запрет коррупционных действий и совершения выплат за содействие / выплат, целью которых является упрощение формальностей в связи с хозяйственной деятельностью, обеспечение более быстрого решения тех или иных вопросов. Стороны, их аффилированные лица, работники, а также посредники и представители, которые прямо или косвенно участвуют в исполнении обязательств Сторонами (в том числе агенты, комиссионеры, таможенные брокеры и иные третьи лица) не принимают, не выплачивают, не предлагают выплатить и не разрешают (санкционируют) выплату/получение каких-либо денежных средств или передачу каких-либо ценностей (в том числе нематериальных) прямо или косвенно, любым лицам, с целью оказания влияния на действия или решения с намерением получить какие-либо неправомерные преимущества, в том числе в обход установленного законодательством порядка, или преследующие иные неправомерные цели. Положения настоящего пункта являются заверениями об обстоятельствах, имеющими для Сторон существенное значение. Стороны полагаются на такие заверения при заключении Договора. В случае нарушения одной из Сторон обязательств по соблюдению требований, предусмотренных настоящим пунктом, Сторона вправе немедленно отказаться от Договора в одностороннем внесудебном порядке, направив письменное уведомление о расторжении. Договор считается расторгнутым по истечении 10 (десяти) календарных дней с даты получения другой Стороной соответствующего письменного уведомления. В случае возникновения у Стороны подозрений, что произошло или может произойти нарушение каких-либо положений настоящего пункта, соответствующая Сторона обязуется как можно скорее уведомить другую Сторону о своих подозрениях в письменной форме. Стороны соглашаются, что будут использовать следующие адреса для уведомления о нарушении/угрозе нарушения настоящего пункта:\n\n',
            'Для уведомления ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ': ',
            { text: 'https://temp03.ru//', link: 'https://temp03.ru//', color: 'blue', decoration: 'underline' },
            ' / ',
            { text: 'info@mail.temp03.ru', link: 'mailto:info@mail.temp03.ru', color: 'blue', decoration: 'underline' },
            '.\n',
            'Для уведомления другой Стороны: адрес, указанный Стороной при осуществлении акцепта Оферты или по адресу местонахождения Стороны согласно сведениям из единого государственного реестра юридических лиц.'
          ],
          margin: [0, 0, 0, 10],
        },
        {
          text: '11. Порядок разрешения споров.',
          style: 'sectionHeader', // or use { text: '...', bold: true } if not using styles
          margin: [0, 10, 0, 8]
        },
        {
          text: [
            { text: '11.1. ', bold: true },
            'Все споры и разногласия, которые могут возникнуть из настоящего Договора или в связи с ним, будут по возможности решаться путем переговоров между Заказчиком и Исполнителем.'
          ],
          margin: [0, 0, 0, 5],
        },
        {
          text: [
            { text: '11.2. ', bold: true },
            'В случае если споры и разногласия не будут решены путем переговоров, они подлежат разрешению в соответствии с действующим законодательством РФ.'
          ],
          margin: [0, 0, 0, 10],
        },
        {
          text: '12. Заключительные положения.',
          style: 'sectionHeader',
          margin: [0, 10, 0, 8]
        },
        {
          text: '12.1. По вопросам, предусмотренным настоящим Договором, стороны руководствуются законодательством РФ.',
          margin: [0, 0, 0, 5]
        },
        {
          text: '12.2. Настоящий Договор составлен в двух экземплярах, имеющих одинаковую юридическую силу: один экземпляр находится у Заказчика, другой у Исполнителя.',
          margin: [0, 0, 0, 5]
        },
        {
          text: '12.3. Приложение № 1 форма Заявка сформированная в сервисе и Приложение № 2 форма расчёта утвержденного в Сервисе temp03, являются неотъемлемой частью настоящего Договор.',
          margin: [0, 0, 0, 5]
        },
        {
          text: '12.4. Договор и его исполнение регулируется в соответствии с законодательством Российской Федерации.',
          margin: [0, 0, 0, 5]
        },
        {
          text: '12.5. Любые уведомления по настоящему Договору направляются уведомляющей Стороной в адрес уведомляемой Стороны по электронной почте, факсом, курьером или почтой с уведомлением о вручении. При этом копии документов, доставленные по электронной почте или по факсу, признаются Сторонами имеющими юридическую силу до момента обмена оригиналами, который Стороны производят в возможно короткие сроки.',
          margin: [0, 0, 0, 5]
        },
        {
          text: [
            '12.6. Стороны установили, что любые сообщения, уведомления в рамках исполнения настоящего Договора должны быть направлены на адреса электронной почты, прямо поименованные настоящим Договором. Для ',
            { text: 'МЕДИТ ТЭМП03', bold: true },
            ' : любые адреса электронной почты с доменом temp03.ru или Для Заказчика: адрес электронной почты, указанный Заказчиком при Процедуре Регистрации, как указано в преамбуле Оферты. В случае изменения адресов электронной почты или доменных имен корпоративных доменов, указанных в настоящем пункте, Сторона должна в письменном виде уведомить другую Сторону в течение 1 (одного) рабочего дня с момента такого изменения. Сторона несет риск возникновения неблагоприятных последствий, вызванных не уведомлением другой Стороны о факте смены адресов электронной почты или доменных имен корпоративных доменов.'
          ],
          margin: [0, 0, 0, 5]
        },
        {
          text: '12.7. Стороны принимают на себя всю ответственность за действия лиц, имеющих доступ к каналам связи, указанным в настоящего Договора. Все действия, совершенные с использованием вышеуказанных каналов связи, являются совершенными надлежащим образом уполномоченными представителями Сторон.',
          margin: [0, 0, 0, 5]
        },
        {
          text: '12.8. В случае изменения реквизитов Сторон, а также перечня ответственных лиц за взаимодействие по Договору, Стороны обязаны уведомить другую Сторону о произошедших изменениях в течение 5 (пяти) рабочих дней путем направления письменного уведомления другой Стороне, а также направления копии текста уведомления по адресу электронной почты.',
          margin: [0, 0, 0, 5]
        },
        {
          text: '12.9. Все акты, приложения, дополнительные соглашения и дополнения к Договору являются неотъемлемой частью Договора.',
          margin: [0, 0, 0, 5]
        },
        {
          text: '12.10. В случае если одно или более положений Договора будут признаны недействительными, такая недействительность не оказывает влияния на действительность любого другого положения Договора и Договора в целом.',
          margin: [0, 0, 0, 5]
        },
        {
          text: '12.11. Все споры и разногласия между Сторонами по Договору, в связи с Договором и/или его исполнением Стороны будут стремиться урегулировать путем переговоров. Применение обязательного досудебного (претензионного) порядка разрешения споров обязательно. Сторона, права которой нарушены, до обращения в суд обязана предъявить другой Стороне письменную претензию с изложением своих требований. Срок рассмотрения претензии — 30 (тридцать) календарных дней со дня ее получения. Если в указанный срок требования не удовлетворены, спор подлежит разрешению в Арбитражном суде г. Москвы.',
          margin: [0, 0, 0, 5]
        },
        {
          text: '12.12. Информация, содержащаяся в Договоре, а также факт заключения Договора имеют конфиденциальный характер. За исключением случаев, прямо указанных в Договоре или предварительно согласованных Сторонами в письменной форме в виде дополнительного соглашения к Договору, ни одна из Сторон не вправе каким-либо образом использовать полное, сокращенное фирменное наименование, товарные знаки, коммерческие обозначения и иные средства индивидуализации, принадлежащие второй Стороне, без предварительного разрешения последней.',
          margin: [0, 0, 0, 5]
        },
        {
          text: '12.13. Слова, означающие только единственное число, также включают множественное число и, наоборот, в зависимости от контекста.',
          margin: [0, 0, 0, 5]
        },
        {
          text: '12.14. После заключения настоящего Договора в предусмотренном порядке, все предыдущие переговоры и переписки Сторон, как в устной, так и в письменной форме, касающиеся его предмета, теряют силу.',
          margin: [0, 0, 0, 10]
        },

        { text: '13. РЕКВИЗИТЫ \n',
          style: 'sectionHeader',
          alignment: 'center',
          margin: [0, 20, 0, 16],
          // pageBreak: 'before'
        },
        {
          columns: [
            {
              width: '50%',
              stack: [
                { text: 'ООО «МЕДИТ ТЭМП03»', },
                { text: 'Адрес: г. Москва, Ломоносовский пр-т, д. 18' },
                { text: 'ИНН 7736314094'},
                { text: 'БИК 044525593'},
                { text: 'КПП 773601001' },
                { text: 'ОГРН 5177746085083' },
                { text: 'БАНК АО «АЛЬФА-БАНК» город Москва,' },
                { text: 'р/с 40702810301300015172' },
                { text: 'корр/счёт 30101810200000000593,\n\n' },
                { text: 'Ген директор: _____________ Вадачкория А.Г.' }
              ]
            },
            {
              width: '50%',
              stack: [
                { text: `Заказчик ${request?.customer?.organization_name}` },
                { text: `${request?.customer?.address}` },
                { text: `ИНН ${request?.customer?.taxpayer_number}` },
                { text: `БИК ${request?.customer?.bic}` },
                { text: `ОГРН ${request?.customer?.register_number}` },
                { text: `БАНК ${request?.customer?.bank_name}` },
                { text: `корр/счёт ${request?.customer?.correspondent_account}` },
                { text: `р/с ${request?.customer?.account} \n\n\n` },
                { text: `М.П. _____________ ${request?.customer?.director_name}` }
              ]
            }
          ],
          columnGap: 30,
          margin: [0, 10, 0, 20]
        }
      ],
      styles: {
        header: { fontSize: 12, margin: [0, 0, 0, 15],  font: 'TimesNewRoman', },
        sectionHeader: { fontSize: 12, margin: [0, 0, 0, 10],  font: 'TimesNewRoman',bold: true, },
        normal: { fontSize: 12,  font: 'TimesNewRoman', },
        smallText: { fontSize: 12, bold: true,   font: 'TimesNewRoman', }
      },
      defaultStyle: {
        font: 'TimesNewRoman',
        fontSize: 12
      },
      footer: function(currentPage, pageCount) {
        return {
          text: `${currentPage} из ${pageCount}`,
          alignment: 'center',
          fontSize: 9,
          margin: [0, 10, 0, 0]
        };
      }
    };

    const docDefinitionFiz = {
      pageMargins: [40, 60, 40, 60],
      content: [
        { text: 'Публичный Договор-оферта на оказание платных медицинских услуг', style: 'header', alignment: 'center', margin: [0, 0, 0, 20] },
        { text: 'ДОГОВОР\nна организацию по оказание разовых медицинских услуг', style: 'subheader', alignment: 'center', margin: [0, 0, 0, 20] },
        { text: `г. ${request.city} «${contract && contract?.created_at ? moment(contract.created_at).format('DD') :now.format('DD')}» ${contract && contract?.created_at ? moment(contract?.created_at).format('MM') :now.format('MM')} ${contract && contract?.created_at ? moment(contract?.created_at).format('YYYY') :now.format('YYYY')}г.`, alignment: 'right', margin: [0, 0, 0, 20] },

        {
          text:
            `ФИО ${request?.name} документ ${request?.customer?.document_name}  № ${request?.customer?.document_number} выдан ${request?.customer?.document_country}`,
        },

        {
          text:
            'именуемый(ая) в дальнейшем «ЗАКАЗЧИК», с одной стороны, и Общество с ограниченной ' +
            'ответственностью «МЕДИТ ГРУПП» в лице Генерального директора Вадачкория Анна Гизоевна, ' +
            'действующего на основании Устава, именуемое в дальнейшем «СЕРВИС», с другой стороны; с ' +
            'привлечением Партнеров Сервиса, имеющих Лицензию на осуществление медицинской деятельности ' +
            `${emergency_org?.inn}, выданная ${emergency_org?.inn_authority}. города ${emergency_city?.city === 3 ? "Санкт-Петербург" : "Москва"}. ${emergency_org?.inn_date} года (срок действия - бессрочно), на ` +
            'выполняемые работы, оказываемые услуги: при оказании медицинских услуг, в том числе скорой ' +
            'специализированной медицинской помощи вне организации, в том числе выездными экстренными ' +
            'консультативными бригадами скорой медицинской помощи, по: анестезиологии и реаниматологии, ' +
            'педиатрии, психиатрии-наркологии, терапии), заключили настоящий Договор о нижеследующем:',
          style: 'normal',
          margin: [0, 0, 0, 20]
        },
        {
          text: 'ОБЩИЕ ПОЛОЖЕНИЯ И ТЕРМИНЫ ИСПОЛЬЗУЕМЫЕ В ДОГОВОРЕ-ОФЕРТЫ',
          style: 'subheader',
          margin: [0, 0, 0, 10]
        },
        {
          text: [
            'Настоящий публичный Договор-оферта на организацию оказания платных медицинских услуг ' +
            '(далее по тексту Договор) в порядке ст. 435, 437 Гражданского Кодекса РФ является ' +
            'публичной офертой, обращенной к физическим лицам, желающим получить соответствующие ' +
            'медицинские услуги. Договор-оферта, опубликованный в сети Интернет по следующим адресам: ',
            { text: 'https://customer.temp03.ru', link: 'https://customer.temp03.ru', color: 'blue', decoration: 'underline' },
            ', а также предоставляемый в целях ознакомления иными способами.\n\n' +
            'Акцепт оферты означает, что Заказчик/Пациент согласен со всеми положениями настоящего ' +
            'предложения и равносилен заключению письменного договора об оказании медицинских услуг.\n\n' +

            'Заказчик — физическое лицо, заказывающее (приобретающее) платные медицинские услуги в ' +
            'соответствии с настоящим Договором в пользу Пациента. Заказчик использует сайты на основании простой (неисключительной) лицензии.\n\n' +

            'Пациент — физическое лицо, в интересах которого Заказчиком заключен настоящий договор в целях оказания медицинских услуг. А также лицо, самостоятельно заказывающее (приобретающее) платные медицинские услуги в соответствии с настоящим Договором. Пациент использует сайты на основании простой (неисключительной) лицензии.\n\n' +

            'Пользователь — Физическое лицо (Пациент), его Представитель, Заказчик которому оказывают медицинские Услуги с использованием Сервиса ТЕМП03, самостоятельно обращаются к исполнителю за получением Услуг через web Сайт, используя мобильный телефон или личный кабинет через ПК.\n\n' +

            'Сервис — программно-аппаратный комплекс, позволяющий Заказчику размещать Запросы на Услуги Партнеров Сервиса и осуществляющий автоматическую обработку и передачу таких Запросов Партнерам Сервиса. Правообладателем программного комплекса ТЕМП03 (temp03) и организатором по предоставлению медицинских услуг Партнёрами Сервиса является ООО «МЕДИТ ГРУПП» (ИНН 7736314094).\n\n' +

            'Услуги Партнеров — услуги, доступные для заказа с использованием Сервиса программного комплекса ТЕМП03 (temp03), оказываемые Партнерами в соответствии с Условиями оказания услуг, информация доступна в сети Интернет по адресу: ',
            { text: 'https://customer.temp03.ru', link: 'https://customer.temp03.ru', color: 'blue', decoration: 'underline' },
            '.\n\nПартнер Сервиса — юридическое лицо, индивидуальный предприниматель, оказывающий Заказчику, Пациенту Услуги при использовании Сервиса ТЕМП03, через web Сайт ',
            { text: 'https://customer.temp03.ru', link: 'https://customer.temp03.ru', color: 'blue', decoration: 'underline' },
            `, используя личный кабинет через ПК и мобильный телефон. Также имеющее Лицензию на осуществление медицинской деятельности, оказывающее услуги в указанной сфере (информация о лицензии представляется по факту оказания медицинской услуги выбранным Партнером Сервиса с указанием /${emergency_org?.inn} / даты начала действия от ${emergency_org?.inn_date} г., кем выдана лицензия в соответствии с перечнем оказываемых медицинских услуг).`
          ],
          style: 'normal',
          margin: [0, 0, 0, 20]
        },
        {
          text: '1. ПРЕДМЕТ ДОГОВОРА',
          style: 'subheader',
          margin: [0, 10, 0, 5]
        },
        {
          text: [
            '1.1. В соответствии с настоящим Договором ',
            { text: 'ООО «МЕДИТ ГРУПП»', bold: true },
            ' (далее по тексту – «Сервис») обязуется организовать оказание от ',
            { text: 'Партнёров Сервиса', bold: true },
            `, Пациенту (${request?.patient_name ? request?.patient_name : request?.name}, ${moment(request?.birthday).format('DD/MM/YYYY')}, +7${request?.contact_number ? request?.contact_number : request?.contact_phone} лицу в интересах, которого Заказчик заключил настоящий договор) на возмездной основе, через разовые медицинские и иные услуги, включающие консультации специалистов, диагностическое обследование (УЗИ лаборатория, КТ, МРТ и др.), а также услуги скорой медицинской помощи, организацию госпитализации, подбор стационара в соответствии с диагнозом Пациента, организацию проведения стационарного лечения в специализированном лечебно-профилактическом учреждении (ЛПУ), медицинское представительство интересов Пациента, разъяснение медицинских аспектов в соответствии с диагнозом Пациента (далее — «услуги»), а Заказчик обязуется оплачивать стоимость предоставляемых услуг `,
            { text: 'выбранных пациентом в приложении программы', bold: true },
            ' ',
            { text: 'https://customer.temp03.ru', link: 'https://customer.temp03.ru', color: 'blue', decoration: 'underline' },
            '. ',
            { text: 'Сервис оказывает услуги путём привлечения лицензированных Партнёр Сервиса', bold: true },
            `, а именно юридических лиц, имеющих Лицензию на осуществление медицинской деятельности по оказанию услуг в указанной сфере (информация о Партнере представляется по факту оказания медицинской услуги с указанием ИНН и Лицензии ${emergency_org?.inn} даты начала действия от ${emergency_org?.inn_date}г., кем выдана в соответствии с перечнем оказываемых медицинских услуг), и осуществить поиск таких предложений по заданным Пользователем параметрам.`
          ],
          style: 'normal',
          margin: [0, 0, 0, 20]
        },
        {
          text: [
            { text: '1.1.1 ', bold: true },
            'Указанные в пункте 1.1. настоящего договора услуги оказываются в соответствии с перечнем предоставляемых Сервисом услуг ',
            { text: 'https://customer.temp03.ru', link: 'https://customer.temp03.ru', color: 'blue', decoration: 'underline' },
            ' и утвержденными на момент обращения тарифами в прайс-листах Партнёров Сервиса, на соответствующих интернет-ресурсах партнёров. Прайс-лист содержит полный перечень услуг, оказание которых возможно в рамках настоящего Договора. Ознакомиться с прайс-листом Исполнителя Заказчик может на Интернет-сайте компании ',
            { text: 'https://customer.temp03.ru', link: 'https://customer.temp03.ru', color: 'blue', decoration: 'underline' },
            ', направив запрос по приложению, выбрав услугу, а также по телефону 8 800 550 3 500 или в центральном офисе компании Исполнителя по адресу: 117393, город Москва, Улица Профсоюзная, Дом 56, Этаж 5, Помещение 59.\n\n',

            { text: '1.2. ', bold: true },
            'При наличии или возникновении в период оказания медицинской помощи у Заказчика/Пациента сопутствующего или дополнительного диагноза, требующего оказания медицинской помощи, медицинские услуги будут оказаны после предварительного согласования с Заказчиком/Пациентом и должны быть оплачены.\n\n',

            { text: '1.3. ', bold: true },
            'При исполнении настоящего Договора Стороны руководствуются действующим законодательством РФ, регулирующим предоставление платных медицинских услуг населению медицинскими учреждениями.\n\n',

            { text: '1.4. ', bold: true },
            'Заказчик / Пациент / Пользователь дает согласие Исполнителю на сбор и обработку персональных данных в порядке и в соответствии с действующим законодательством РФ.\n\n',

            { text: '1.5. ', bold: true },
            'Стороны соглашаются с тем, что Заказчик/Пациент информирован о том, что граждане, находящиеся на лечении, в соответствии с Федеральным законом «Об основах здоровья граждан в Российской Федерации» обязаны соблюдать режим лечения, в том числе определенный на период их временной нетрудоспособности, и правила поведения пациента в медицинских организациях. Также Заказчик/Пациент информирован Исполнителем о возможности получения без взимания платы соответствующих видов и объемов медицинской помощи в рамках программ государственных гарантий бесплатного оказания гражданам медицинской помощи в соответствии с перечнем заболеваний и состояний, оказание медицинской помощи при которых осуществляется бесплатно в медицинских организациях, участвующих в реализации программы государственных гарантий.\n\n',

            { text: '1.6. ', bold: true },
            'Стороны согласились, что при заключении настоящего договора они вправе пользоваться факсимильным воспроизведением подписи с помощью средств механического или иного копирования, электронно-цифровой подписи либо иного аналога собственноручной подписи.\n\n',

            { text: '1.7. ', bold: true },
            'В соответствии со ст.32 Основ законодательства «Об охране здоровья граждан РФ» Заказчик/Пациент дает информированное согласие на медицинские манипуляции в отношении Пациента с учетом риска возможных осложнений при получении медицинских услуг от Партнёров Сервиса.\n\n',

            { text: '1.8. ', bold: true },
            'Взаимодействие Пользователя с Партнерами Сервиса по вопросам приобретения услуг осуществляется Пользователем самостоятельно (без участия Правообладателя) в соответствии с принятыми у Партнеров Сервиса правилами оказания услуг. Правообладатель не несет ответственности за финансовые и любые другие операции, совершаемые Пользователем и Партнерами Сервиса, а также за любые последствия приобретения Пользователем услуг Партнера Сервиса вне программного комплекса.'
          ],
          style: 'normal',
          margin: [0, 0, 0, 20]
        },
        {
          text: '2. ПРАВА И ОБЯЗАННОСТИ ИСПОЛНИТЕЛЯ',
          style: 'subheader',
          margin: [0, 10, 0, 5]
        },
        {
          text: [
            { text: '2.1. ', bold: true },
            'Сервис обязуется организовать оказание истребованные для Пациента Заказчиком услуги в соответствии с условиями настоящего Договора.\n\n',

            { text: '2.2. ', bold: true },
            'Сервис обязан обеспечить оказание медицинских услуг в соответствии с медицинскими стандартами и методиками, разрешенными к применению Министерством здравоохранения Российской Федерации.\n\n',

            { text: '2.3. ', bold: true },
            'Сервис по требованию Заказчика обязан обеспечить выдачу врачебного заключения, содержащего наименование полученной услуги, а также медицинскую информацию касательно состояния здоровья Пациента. При необходимости, в рамках получения медицинской услуги, могут оформляться иные, предусмотренные законодательством документы.\n\n',

            { text: '2.4. ', bold: true },
            'Сервис вправе привлекать третьих лиц к исполнению своих обязанностей по настоящему договору.\n\n',

            { text: '2.5. ', bold: true },
            'В случае привлечения стороннего медицинского учреждения для оказания медицинских услуг Пациенту, ответственность за качество оказания медицинской услуги, исходя из Закона РФ от 07.02.1992 №2300-1 «О защите прав потребителей», несет медицинское учреждение, непосредственно оказавшее медицинскую услугу.'
          ],
          style: 'normal',
          margin: [0, 0, 0, 20]
        },
        {
          text: '3. ПРАВА И ОБЯЗАННОСТИ ЗАКАЗЧИКА',
          style: 'subheader',
          margin: [0, 10, 0, 5]
        },
        {
          text: [
            { text: '3.1. ', bold: true },
            'Заказчик / Пациент самостоятельно, на основе действующих и предоставленных Сервисом тарифов, определяет фактический перечень услуг, которые он желает получить для Заказчика / Пациента в рамках настоящего Договора.\n\n',

            { text: '3.2. ', bold: true },
            'Настоящий договор заключен на основании устной либо через web-приложение Сервиса ',
            { text: 'https://customer.temp03.ru', link: 'https://customer.temp03.ru', color: 'blue', decoration: 'underline' },
            ' заявки Заказчика / Пациента и в соответствии с Правилами предоставления платных медицинских услуг населению медицинскими учреждениями (утв. Постановлением Правительства РФ от 13 января 1996 г. №27). Пациенту разъяснено, а Пациентом понято, что многие из оказываемых медицинских услуг включены в территориальную программу государственных гарантий оказания гражданам бесплатной медицинской помощи. Заказчик / Пациент добровольно принимает на себя обязательство оплатить оказанные медицинские услуги в соответствии с п.4 настоящего договора в порядке и на условиях, предусмотренных настоящим договором.'
          ],
          style: 'normal',
          margin: [0, 0, 0, 20]
        },
        {
          text: '4. СТОИМОСТЬ УСЛУГ И ПОРЯДОК РАСЧЕТОВ',
          style: 'subheader',
          margin: [0, 10, 0, 5]
        },
        {
          text: [
            { text: '4.1. ', bold: true },
            { text: 'Стоимость медицинских услуг Название услуги по факту: ' }, {text: `${request?.invoice[0].text}, `, bold: true}, 'по настоящему Договору составляет рублей ',
            {text: `${totalSum} `, bold: true}, { text: `(${convertNumberToWordsRu(totalSum)}) без НДС. `, bold: true, margin: [0, 0, 0, 20] },
            "Не облагается НДС на основании ст. 149 пп.2 п.2 Налогового кодекса Российской Федерации. ",
            {text: `Подробно ознакомиться с порядком оказания выбранной услуги возможно в разделе Условия и Правила платформы Сервиса temp03, `, bold: true},
            { text: 'https://customer.temp03.ru/terms-and-rules', link: 'https://customer.temp03.ru/terms-and-rules.', color: 'blue', decoration: 'underline' },
          ],
          style: 'normal',
          margin: [0, 0, 0, 20]
        },
        {
          table: {
            headerRows: 1,
            widths: [30, '*', 70, 60, 60, 60],
            body: [
              [
                { text: '№', style: 'tableHeader', alignment: 'center' },
                { text: 'Наименование услуги', style: 'tableHeader', alignment: 'center' },
                { text: 'Количество', style: 'tableHeader', alignment: 'center' },
                { text: 'Ед.', style: 'tableHeader', alignment: 'center' },
                { text: 'Цена', style: 'tableHeader', alignment: 'center' },
                { text: 'Сумма', style: 'tableHeader', alignment: 'center' }
              ],
              ...request?.invoice.map((item, index) => [
                { text: `${index + 1}`, border: [true, true, true, true] },
                { text: item.text, border: [true, true, true, true] },
                { text: item.qty, border: [true, true, true, true] },
                { text: item.eta, border: [true, true, true, true] },
                { text: item.price, border: [true, true, true, true] },
                { text: item.total, border: [true, true, true, true] }
              ])
            ]
          },
          layout: {
            hLineWidth: () => 0.5,
            vLineWidth: () => 0.5
          },
          margin: [0, 10, 0, 20]
        },
        {
          columns: [
            {
              width: '60%',
              text: '',
              margin: [0, 0, 0, 0]
            },
            {
              width: '40%',
              columns: [
                {
                  width: '50%',
                  stack: [
                    {
                      text: `Итого: `,
                      style: 'bold',
                      margin: [0, 0, 0, 0]
                    },
                    {
                      text: 'Без налога (НДС)',
                      style: 'bold',
                      margin: [0, 0, 0, 0]
                    },
                  ]
                },
                {
                  width: '50%',
                  stack: [
                    {
                      text: `${totalSum.toFixed(2)}`,
                      style: 'bold',
                      alignment: 'right',
                      margin: [0, 0, 0, 0]
                    },
                    {
                      text: '-',
                      style: 'bold',
                      alignment: 'right',
                      margin: [0, 0, 0, 0]
                    },
                  ]
                }
              ]
            }
          ]
        },
        { text: `\nВсего наименований ${request?.invoice.length}, на сумму: ${totalSum.toFixed(2)} руб.`, margin: [0, 0, 0, 0] },
        { text: `(Сумма прописью) ${convertNumberToWordsRu(totalSum)}`, style: "bold", margin: [0, 0, 0, 20] },
        {
          text: [
            { text: '4.2. ', bold: true },
            'Стоимость услуг, оказываемых в соответствии с настоящим договором, определена на основании действующих тарифов прайс-листов Партнёров Сервиса, а так же на основании тарифов предложенных при формировании заявки в web приложение Сервиса',
            { text: ' https://customer.temp03.ru ', link: 'https://customer.temp03.ru', color: 'blue', decoration: 'underline' }, "и подтверждаются документом об оплате.\n\n",

            { text: '4.3. ', bold: true },
            'Оплата услуг Сервиса производится Заказчиком в наличной или безналичной форме (банковской картой), а также через иные платёжные системы, разрешённые к использованию в расчетах между физическим и юридическим лицом на территории РФ в рублях.\n\n',

            { text: '4.4. ', bold: true },
            'Заказчик / Пациент в момент заключения настоящего Договора оплачивает Исполнителю авансовый платёж в качестве предоплаты согласно предварительным расчётам Исполнителя за выбранные услуги по настоящему Договору.\n\n',

            { text: '4.5. ', bold: true },
            'Авансовый платеж  вносится безналичным способом согласно инструментариям, размещенным на интернет площадках www//temp03.ru// либо наличными денежными средствами, либо любым из способов, указанных на официальном сайте Сервиса', { text: ' https://customer.temp03.ru \n\n', link: 'https://customer.temp03.ru', color: 'blue', decoration: 'underline' },
            'Факт оплаты является согласием/акцептом Заказчика/Пациента с условиями настоящего договора оферты. \n\n',

            { text: '4.6. ', bold: true },
            'Авансовый платёж (предоплата) рассчитывается исходя из предварительного выбора услуг и сформированной заявки Заказчиком.\n\n',

            { text: '4.7. ', bold: true },
            'В случае возникновения необходимости увеличения объёма медицинских услуг или израсходования авансового платежа более чем на 70%, Заказчик / Пациент обязан оплатить дополнительный платёж (внести предоплату) в течение одних суток с даты уведомления о данном факте. До внесения необходимой суммы Исполнитель вправе приостановить оказание медицинских услуг Пациенту.\n\n',

            { text: '4.8. ', bold: true },
            'В случае наличия при окончательных расчётах неиспользованной суммы авансового платежа, данная сумма подлежит возврату Заказчику в течение 10 рабочих дней с даты подтверждения Заказчиком, что все услуги получены, а также если Пациент был госпитализирован — с даты выписки Пациента.\n\n',

            { text: '4.9. ', bold: true },
            'В случае отказа Пациента от оплаченных услуг, по письменному заявлению Пациента Исполнителем осуществляется возврат сумм по не предоставленным услугам. В таком случае Договор считается расторгнутым.\n\n',

            { text: '4.10. ', bold: true },
            'В случае досрочного расторжения Договора Исполнитель возвращает Заказчику сумму авансового платежа за вычетом расходов на оказание медицинских услуг в течение 10 рабочих дней с даты получения полных сведений о полученных медицинских услугах Пациентом.'
          ],
          style: 'normal',
          margin: [0, 0, 0, 20]
        },
        {
          text: '5. УСЛОВИЯ И ПОРЯДОК ОКАЗАНИЯ УСЛУГ',
          style: 'subheader',
          margin: [0, 10, 0, 5]
        },
        {
          text: [
            { text: '5.1. ', bold: true },
            'Сервис оказывает услуги, а Заказчик осуществляет их оплату. Полным и безоговорочным акцептом настоящей публичной оферты является осуществление Заказчиком / Пациентом предварительной оплаты.\n\n',

            { text: '5.2. ', bold: true },
            'Заказчик / Пациент, заключая настоящий Договор, проинформирован о ценах на медицинские услуги одним из следующих способов: ознакомление с тарифами на Сервисе ТЕМП03, предложенными Партнёрами Сервиса на момент обращения, а также размещёнными на интернет-ресурсах партнёров согласно п. 1.1.1 настоящего договора.\n\n',

            { text: '5.3. ', bold: true },
            'Стороны пришли к соглашению, что оказание услуг осуществляется исключительно в рамках предоплаты и все расчёты по настоящему договору осуществляются на основе предоплаты путём внесения авансового платежа, согласно разделу 4.\n\n',

            { text: '5.4. ', bold: true },
            'Заказчику / Пациенту разъяснено и понятно, что большинство из оказываемых медицинских услуг включено в территориальную программу государственных гарантий оказания гражданам бесплатной медицинской помощи. Заказчик добровольно принимает на себя обязательство оплатить оказанные медицинские услуги в порядке и на условиях, предусмотренных настоящим договором.'
          ],
          style: 'normal',
          margin: [0, 0, 0, 20]
        },
        {
          text: '6. СРОК ДЕЙСТВИЯ ДОГОВОРА',
          style: 'subheader',
          margin: [0, 10, 0, 5]
        },
        {
          text: [
            { text: '6.1. ', bold: true },
            `${contractStart} ${contractEnd}\n\n`,

            { text: '6.2. ', bold: true },
            'Настоящий Договор вступает в силу с момента подписания сторонами и действует до момента исполнения сторонами обязательств по настоящему Договору. Прекращение настоящего Договора освобождает стороны от исполнения обязательств по Договору только после того, как они выполнят свои обязательства, возникшие у них до прекращения настоящего Договора, в полном объеме. что подтверждается подписанием Акта сдачи-приемки услуг.'
          ],
          style: 'normal',
          margin: [0, 0, 0, 20]
        },
        {
          text: '7. ОТВЕТСТВЕННОСТЬ СТОРОН',
          style: 'subheader',
          margin: [0, 10, 0, 5]
        },
        {
          text: [
            { text: '7.1. ', bold: true },
            'Стороны обязуются принимать к рассмотрению и давать письменные мотивированные ответы на претензии другой Стороны в течение 10 рабочих дней с даты предъявления претензий, исправлять допущенные упущения и учитывать в последующей работе законные требования, содержащиеся в претензии.\n\n',

            { text: '7.2. ', bold: true },
            'Сторона, не исполнившая или ненадлежащим образом исполнившая обязательство, не несёт ответственности, если данное обстоятельство было обусловлено наличием обстоятельств непреодолимой силы.\n\n',

            { text: '7.3. ', bold: true },
            'Исполнитель освобождается от ответственности за неисполнение или ненадлежащее исполнение настоящего Договора, причиной которого стало нарушение Заказчиком условий настоящего Договора, а также по иным основаниям, предусмотренным законодательством РФ.\n\n',

            { text: '7.4. ', bold: true },
            'В случае нарушения Заказчиком / Пациентом п. 4.4 настоящего Договора Заказчик / Пациент уплачивает Исполнителю неустойку в размере 0,5 (ноль целых пять десятых процента) от общей суммы задолженности за каждый день просрочки.\n\n',

            { text: '7.5. ', bold: true },
            'Уплата неустойки не освобождает Заказчика / Пациента от оплаты стоимости предоставленных Исполнителем услуг.'
          ],
          style: 'normal',
          margin: [0, 0, 0, 20]
        },
        {
          text: '8. РАССМОТРЕНИЕ СПОРОВ',
          style: 'subheader',
          margin: [0, 10, 0, 5]
        },
        {
          text: [
            { text: '8.1. ', bold: true },
            'Все споры, вытекающие из настоящего Договора, разрешаются Сторонами путём переговоров. В случае невозможности урегулирования спора путём переговоров, спор подлежит разрешению в судебном порядке по месту исполнения настоящего Договора в соответствии с действующим законодательством РФ.'
          ],
          style: 'normal',
          margin: [0, 0, 0, 20]
        },
        {
          text: '9. ЗАКЛЮЧИТЕЛЬНЫЕ ПОЛОЖЕНИЯ',
          style: 'subheader',
          margin: [0, 10, 0, 5]
        },
        {
          text: [
            { text: '9.1. ', bold: true },
            'В соответствии со ст. 20 Основ законодательства «Об охране здоровья граждан РФ» даю информированное согласие на медицинское вмешательство с учётом риска возможных осложнений. Я также подтверждаю правдивость всей переданной врачу информации о состоянии моего здоровья, ничего не скрывая. С условиями и порядком оплаты медицинских услуг ООО «МЕДИТ ГРУПП» ознакомлен(а) и согласен(а).'
          ],
          style: 'normal',
          margin: [0, 0, 0, 30]
        },
        {
          text: '10. АДРЕСА И РЕКВИЗИТЫ СТОРОН',
          style: 'subheader',
          margin: [0, 10, 0, 10]
        },
        {
          columns: [
            {
              width: '50%',
              stack: [
                { text: 'Сервис ТЕМП03\nООО «МЕДИТ ГРУПП»', bold: true },
                { text: '119296, г. Москва,\nЛомоносовский пр-т, д. 18, этаж 1, пом. XXIX, ком. 1–5' },
                { text: 'ИНН: 7736314094' },
                { text: 'КПП: 773601001' },
                { text: 'ОГРН: 5177746085083' },
                { text: 'БИК: 044525593' },
                { text: 'Банк: АО «АЛЬФА-БАНК»' },
                { text: 'Р/с: 40702810301300015172' },
                { text: 'К/с: 30101810200000000593' },
                { text: 'Телефон: 8 964 537 22 53' },
                { text: 'E-mail: info@mail.temp.ru', margin: [0, 0, 0, 10] },
                { text: 'Ген директор: _____________ Вадачкория А.Г.' },
              ]
            },
            {
              width: '50%',
              stack: [
                { text: 'Заказчик', bold: true, margin: [0, 0, 0, 5] },
                { text: `${request?.customer?.name}` },
                { text: `Тип документа: ${request?.customer?.document_name}` },
                { text: `серия, №: ${request?.customer?.document_number}` },
                { text: `Выдан: ${request?.customer?.document_country}` },
                { text: `Дата выдачи: ${moment(request?.customer?.document_date).format('DD/MM/YYYY')}` },
                { text: `Телефон: ${request?.customer?.primary_phone}` },
                { text: `E-mail: ${request?.customer?.email}`, margin: [0, 0, 0, 10] },
                { text: 'С условиями Договора и порядком оплаты медицинских услуг ознакомлен(на), согласен(на) \n\n', margin: [0, 10, 0, 10] },
                { text: `_____________ ${request?.customer?.name}` },
                // {
                //   columns: [
                //     { text: `_____________ ${request?.customer?.name}` },
                //   ]
                // },
                // {
                //   columns: [
                //     { text: 'подпись', alignment: 'left', italics: true, fontSize: 10 },
                //     { text: 'расшифровка', alignment: 'right', italics: true, fontSize: 10 }
                //   ]
                // }
              ]
            }
          ],
          columnGap: 30,
          margin: [0, 0, 0, 30]
        }
      ],
      styles: {
        header: { fontSize: 18, bold: true },
        subheader: { fontSize: 14, bold: true },
        normal: { fontSize: 12 },
        tableHeader: { bold: true, fontSize: 12 }
      },
      defaultStyle: {
        font: 'TimesNewRoman'
      }
    };



  // Generate PDF as Blob and create object URL
    pdfMake.createPdf(request.customer_type === 2 ? docDefinition : docDefinitionFiz ).getBlob((blob) => {
      const url = URL.createObjectURL(blob);
      setPdfUrl(url);
      setGeneratedContract(blob)
    });
  };

  useEffect(() => {
    generatePdf()
  }, [])
  return (
    <div  style={{height: "100%"}}>
      {pdfUrl && (
        <div style={{height: isShowContract ? "70vh" : "64vh"}}>
          <iframe
            src={pdfUrl}
            title="Contract PDF"
            style={{ width: "100%", height: "100%", border: "none", textAlign: "center" }}
          />
        </div>
      )}
    </div>
  );
};

export default GenerateContract;




